import { useContext, useEffect, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, Button, CustomContainer, FlexRow, Form, FormGroup, ScreenTitle } from "src/style"
import { NewPin } from "src/component"

export const ForgotPin: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({securityQuestion1: '', securityQuestion2: '', securityAnswer1: '', securityAnswer2: ''})
    const [view, setView] = useState('forgot-pin')

    useEffect(() => {
        handleFetchSecurityQuestions()
    }, [])

    async function handleFetchSecurityQuestions () {
        const response = await API.getSecurityQuestionsByUsername()
        if (response) setInput({...input, securityQuestion1: response.securityQuestion1, securityQuestion2: response.securityQuestion2})
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})
    
    function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('set-pin')
    }

    async function handleSubmit (newPin: string) {
        const payload = {...input, newPin}
        await API.resetPin(payload)
        close()
    }

    return (
        <>
            { view === 'forgot-pin' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700" bottomMargin="2.5">Forgot PIN</ScreenTitle>
                    <AppSpan>Answer the following Security Questions</AppSpan>
                    <CustomContainer topMargin='2'>
                        <Form onSubmit={handleProceed}>
                            <FormGroup>
                                <label>{input.securityQuestion1}</label>
                                <input 
                                    placeholder='Enter Answer' 
                                    name='securityAnswer1'
                                    value={input.securityAnswer1}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>{input.securityQuestion2}</label>
                                <input 
                                    placeholder='Enter Answer' 
                                    name='securityAnswer2'
                                    value={input.securityAnswer2}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            
                            <FlexRow justifyContent='flex-end' topMargin='2.5'>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'set-pin' &&
                <NewPin
                    close={close}
                    shouldConfirm
                    next={handleSubmit} 
                />
            }
        </>
    )
}